import { defineMessages, plural } from "../i18n/core";

// Compartilhamentos SMB copiados por esta máquina (ADR 0030).
export const machineSharesMessages = defineMessages({
  "pt-BR": {
    intro: "Esta máquina lê o compartilhamento pela rede (SMB 2 ou 3, sem montar nada) e guarda os arquivos como um backup comum: navegação, ZIP e restauração funcionam igual. Serve para NAS e para servidores onde o agente não roda.",
    add: "Adicionar compartilhamento",
    none: "Nenhum compartilhamento cadastrado nesta máquina.",
    credentialNamed: (name: string) => `credencial ${name}`,
    credentialSome: "com credencial",
    credentialNone: "acesso anônimo",
    scheduleOwn: (time: string) => `todo dia às ${time}`,
    scheduleHourly: "de hora em hora",
    scheduleFromPolicy: "agenda da política",
    disabled: "Desligado",
    disabledHint: "Não copia pela agenda; teste e backup na hora continuam valendo.",
    neverTested: "Ainda não testado",
    testOk: (when: string) => `Teste aprovado ${when}`,
    testFailed: (when: string) => `Teste falhou ${when}`,
    testInfo: (dialect: string, entries: string, bytes: string) => `SMB ${dialect} · ${entries} itens vistos, ${bytes}`,
    signed: "sessão assinada",
    encrypted: "sessão cifrada",
    test: "Testar",
    testing: "Testando…",
    testSteps: "Passos do teste",
    stepStatus: { ok: "feito", warn: "aviso", fail: "falhou" },
    backupNow: "Backup agora",
    backingUp: "Copiando…",
    edit: "Editar",
    remove: "Remover",
    testSent: (name: string) => `Teste de ${name} enviado ao agente.`,
    backupSent: (name: string) => `Backup de ${name} enviado ao agente.`,
    actionFailed: "Não foi possível enviar o pedido.",
    points: "Pontos de restauração",
    noPoints: "Nenhum backup deste compartilhamento ainda.",
    colWhen: "Backup",
    colFiles: "Arquivos",
    colSize: "Tamanho",
    colActions: "Ações",
    when: (date: string, time: string) => `${date} às ${time}`,
    triggerManual: "manual",
    triggerSchedule: "agendado",
    files: (n: number) => `${n} ${plural(n, "arquivo", "arquivos")}`,
    restore: "Restaurar",
    removeTitle: (name: string) => `Remover ${name}?`,
    removeDescription: "Sai só o cadastro. Os pontos de restauração ficam até a retenção da política apagar.",
    removed: (name: string) => `${name} removido.`,
    removeFailed: "Não foi possível remover.",

    createTitle: "Novo compartilhamento",
    editTitle: (name: string) => `Editar ${name}`,
    fieldName: "Nome",
    namePlaceholder: "Documentos do NAS",
    fieldHost: "Servidor",
    hostHint: "Nome ou endereço do servidor de arquivos ou do NAS, como esta máquina o enxerga.",
    fieldShare: "Compartilhamento",
    shareHint: "Só o nome, sem \\\\ e sem a pasta.",
    fieldPath: "Pasta inicial",
    pathHint: "Dentro do compartilhamento; vazio é a raiz.",
    fieldCredential: "Credencial",
    credentialNoneOption: "Sem credencial (acesso anônimo)",
    credentialHint: "Cadastre e troque senhas em Configurações › Credenciais. A senha só sai do servidor durante um teste ou backup.",
    credentialReadOnly: "Só um administrador da organização altera a credencial.",
    fieldExclude: "Exclusões",
    excludeHint: "Um padrão por linha, como na política: *.tmp, ~$*, **/Thumbs.db.",
    fieldSchedule: "Agenda",
    schedulePolicy: "A da política",
    scheduleCustom: "Própria",
    fieldTime: "Horário",
    fieldWindow: "Janela (horas)",
    fieldDays: "Dias",
    enabled: "Copiar pela agenda",
    create: "Cadastrar",
    save: "Salvar",
    created: (name: string) => `${name} cadastrado. Rode um teste antes do primeiro backup.`,
    saved: (name: string) => `${name} salvo.`,
    saveFailed: "Não foi possível salvar.",
    nameRequired: "Dê um nome ao compartilhamento.",
    hostRequired: "Informe o servidor.",
    shareRequired: "Informe o nome do compartilhamento.",
  },
  "en-US": {
    intro: "This machine reads the share over the network (SMB 2 or 3, nothing mounted) and stores the files as a regular backup: browsing, ZIP and restore work the same. Use it for a NAS and for servers where the agent cannot run.",
    add: "Add share",
    none: "No share registered on this machine.",
    credentialNamed: (name: string) => `credential ${name}`,
    credentialSome: "with credential",
    credentialNone: "anonymous access",
    scheduleOwn: (time: string) => `every day at ${time}`,
    scheduleHourly: "hourly",
    scheduleFromPolicy: "policy schedule",
    disabled: "Off",
    disabledHint: "Not backed up on schedule; test and backup now still work.",
    neverTested: "Not tested yet",
    testOk: (when: string) => `Test passed ${when}`,
    testFailed: (when: string) => `Test failed ${when}`,
    testInfo: (dialect: string, entries: string, bytes: string) => `SMB ${dialect} · ${entries} items seen, ${bytes}`,
    signed: "signed session",
    encrypted: "encrypted session",
    test: "Test",
    testing: "Testing…",
    testSteps: "Test steps",
    stepStatus: { ok: "done", warn: "warning", fail: "failed" },
    backupNow: "Back up now",
    backingUp: "Copying…",
    edit: "Edit",
    remove: "Remove",
    testSent: (name: string) => `Test of ${name} sent to the agent.`,
    backupSent: (name: string) => `Backup of ${name} sent to the agent.`,
    actionFailed: "The request could not be sent.",
    points: "Restore points",
    noPoints: "No backup of this share yet.",
    colWhen: "Backup",
    colFiles: "Files",
    colSize: "Size",
    colActions: "Actions",
    when: (date: string, time: string) => `${date} at ${time}`,
    triggerManual: "manual",
    triggerSchedule: "scheduled",
    files: (n: number) => `${n} ${plural(n, "file", "files")}`,
    restore: "Restore",
    removeTitle: (name: string) => `Remove ${name}?`,
    removeDescription: "Only the registration goes away. Restore points stay until the policy's retention deletes them.",
    removed: (name: string) => `${name} removed.`,
    removeFailed: "Could not remove.",

    createTitle: "New share",
    editTitle: (name: string) => `Edit ${name}`,
    fieldName: "Name",
    namePlaceholder: "NAS documents",
    fieldHost: "Server",
    hostHint: "Name or address of the file server or NAS, as this machine sees it.",
    fieldShare: "Share",
    shareHint: "Just the name, without \\\\ and without the folder.",
    fieldPath: "Starting folder",
    pathHint: "Inside the share; empty is the root.",
    fieldCredential: "Credential",
    credentialNoneOption: "No credential (anonymous access)",
    credentialHint: "Register and rotate passwords under Settings › Credentials. The password only leaves the server during a test or backup.",
    credentialReadOnly: "Only an organization administrator changes the credential.",
    fieldExclude: "Exclusions",
    excludeHint: "One pattern per line, as in the policy: *.tmp, ~$*, **/Thumbs.db.",
    fieldSchedule: "Schedule",
    schedulePolicy: "The policy's",
    scheduleCustom: "Its own",
    fieldTime: "Time",
    fieldWindow: "Window (hours)",
    fieldDays: "Days",
    enabled: "Back up on schedule",
    create: "Register",
    save: "Save",
    created: (name: string) => `${name} registered. Run a test before the first backup.`,
    saved: (name: string) => `${name} saved.`,
    saveFailed: "Could not save.",
    nameRequired: "Give the share a name.",
    hostRequired: "Enter the server.",
    shareRequired: "Enter the share name.",
  },
  es: {
    intro: "Este equipo lee el recurso compartido por la red (SMB 2 o 3, sin montar nada) y guarda los archivos como una copia común: navegar, ZIP y restaurar funcionan igual. Sirve para NAS y para servidores donde el agente no se ejecuta.",
    add: "Agregar recurso compartido",
    none: "Ningún recurso compartido registrado en este equipo.",
    credentialNamed: (name: string) => `credencial ${name}`,
    credentialSome: "con credencial",
    credentialNone: "acceso anónimo",
    scheduleOwn: (time: string) => `todos los días a las ${time}`,
    scheduleHourly: "cada hora",
    scheduleFromPolicy: "horario de la política",
    disabled: "Apagado",
    disabledHint: "No se copia por horario; la prueba y la copia inmediata siguen valiendo.",
    neverTested: "Todavía no probado",
    testOk: (when: string) => `Prueba aprobada ${when}`,
    testFailed: (when: string) => `La prueba falló ${when}`,
    testInfo: (dialect: string, entries: string, bytes: string) => `SMB ${dialect} · ${entries} elementos vistos, ${bytes}`,
    signed: "sesión firmada",
    encrypted: "sesión cifrada",
    test: "Probar",
    testing: "Probando…",
    testSteps: "Pasos de la prueba",
    stepStatus: { ok: "hecho", warn: "aviso", fail: "falló" },
    backupNow: "Copiar ahora",
    backingUp: "Copiando…",
    edit: "Editar",
    remove: "Quitar",
    testSent: (name: string) => `Prueba de ${name} enviada al agente.`,
    backupSent: (name: string) => `Copia de ${name} enviada al agente.`,
    actionFailed: "No se pudo enviar la solicitud.",
    points: "Puntos de restauración",
    noPoints: "Todavía no hay copias de este recurso compartido.",
    colWhen: "Copia",
    colFiles: "Archivos",
    colSize: "Tamaño",
    colActions: "Acciones",
    when: (date: string, time: string) => `${date} a las ${time}`,
    triggerManual: "manual",
    triggerSchedule: "programada",
    files: (n: number) => `${n} ${plural(n, "archivo", "archivos")}`,
    restore: "Restaurar",
    removeTitle: (name: string) => `¿Quitar ${name}?`,
    removeDescription: "Solo se quita el registro. Los puntos de restauración se conservan hasta que la retención de la política los borre.",
    removed: (name: string) => `${name} quitado.`,
    removeFailed: "No se pudo quitar.",

    createTitle: "Nuevo recurso compartido",
    editTitle: (name: string) => `Editar ${name}`,
    fieldName: "Nombre",
    namePlaceholder: "Documentos del NAS",
    fieldHost: "Servidor",
    hostHint: "Nombre o dirección del servidor de archivos o del NAS, como lo ve este equipo.",
    fieldShare: "Recurso compartido",
    shareHint: "Solo el nombre, sin \\\\ y sin la carpeta.",
    fieldPath: "Carpeta inicial",
    pathHint: "Dentro del recurso compartido; vacía es la raíz.",
    fieldCredential: "Credencial",
    credentialNoneOption: "Sin credencial (acceso anónimo)",
    credentialHint: "Registra y cambia contraseñas en Configuración › Credenciales. La contraseña solo sale del servidor durante una prueba o una copia.",
    credentialReadOnly: "Solo un administrador de la organización cambia la credencial.",
    fieldExclude: "Exclusiones",
    excludeHint: "Un patrón por línea, como en la política: *.tmp, ~$*, **/Thumbs.db.",
    fieldSchedule: "Horario",
    schedulePolicy: "El de la política",
    scheduleCustom: "Propio",
    fieldTime: "Hora",
    fieldWindow: "Ventana (horas)",
    fieldDays: "Días",
    enabled: "Copiar por horario",
    create: "Registrar",
    save: "Guardar",
    created: (name: string) => `${name} registrado. Ejecuta una prueba antes de la primera copia.`,
    saved: (name: string) => `${name} guardado.`,
    saveFailed: "No se pudo guardar.",
    nameRequired: "Dale un nombre al recurso compartido.",
    hostRequired: "Indica el servidor.",
    shareRequired: "Indica el nombre del recurso compartido.",
  },
});
